import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { ApiConstant } from '../../constants';

function useFlagsFromBackend (flags, isAdmin=false) {
  const [state, setState] = useState({ $flagsReady: false });
  useEffect(() => {
    if (state.$flagsReady || (!localStorage.getItem('token') && !isAdmin) || (isAdmin && !localStorage.getItem('adminToken'))) return;
    const endPoint = isAdmin ? 'darkly/admin' : 'darkly/'
    axios.post(`${ApiConstant.BASE_URL}${endPoint}`, { flags })
      .then(result => {
        return result.data;
      })
      .then(({ result, success }) => {
        if (success) {
          setState({ ...result, $flagsReady: true });
        } else {
          setState({ $flagsReady: true });
        }
      })
      .catch(error => {
        console.error(error);
        setState({ $flagsReady: true });
      });
  }, [state.$flagsReady]);
  return state;
}

function withLDFlagsFromBackend (Component, flagsList = [], isAdmin=false) {
  return (props) => {
    const flags = useFlagsFromBackend(flagsList, isAdmin);
    return <Component {...props} LDFlags={flags} />;
  };
}

const JobsPages = {
  old_recommended_jobs_page: 'old_recommended_jobs_page',
  new_jobs_dashboard: 'new_jobs_dashboard',
  new_recommended_jobs_tab: 'new_recommended_jobs_tab',
  new_job_applicatons_tab: 'new_job_applicatons_tab'
};

const isJobPageFeatureEnabled = (jobPageFlagValue, pageName) => {
  const {
      isOldRecommendedJobsEnabled = false,
      isNewJobDashboardEnabled = false,
      isNewRecommendedJobsTabEnabled = false,
      isNewJobApplicationsTabEnabled = false,
  } = jobPageFlagValue || {};

    // Check if the relevant flag is enabled for the specified page
    switch (pageName) {
      case JobsPages.old_recommended_jobs_page:
        return isOldRecommendedJobsEnabled;
      case JobsPages.new_jobs_dashboard:
        return isNewJobDashboardEnabled;
      case JobsPages.new_recommended_jobs_tab:
        return isNewJobDashboardEnabled && isNewRecommendedJobsTabEnabled
      case JobsPages.new_job_applicatons_tab:
        return isNewJobDashboardEnabled && isNewJobApplicationsTabEnabled
      default:
       return false;
    }
};

const GB_FLAGS = {
  acc_anytime: 'acc_anytime',
  mcqfilter: 'mcqfilter',
  gb_semi_vetted: 'gb_semi_vetted',
  auto_redirect_to_acc_page: 'auto_redirect_to_acc_page',
  auto_redirect_to_test_page: 'auto_redirect_to_test_page',
  enable_cloud_challenges: 'enable_cloud_challenges',
  enable_developer_availability_api_for_vettting: 'enable_developer_availability_api_for_vettting',
  enable_developer_availability_api_vetting: 'enable_developer_availability_api_vetting',
  enable_developer_rate_api_for_vetting: 'enable_developer_rate_api_for_vetting',
  enable_latam_reward: 'enable_latam_reward',
  enable_linkedin_sync: 'enable_linkedin_sync',
  enable_welcome_call: 'enable_welcome_call',
  finalizeresumepagenewvsold: 'finalizeresumepagenewvsold',
  gb_cloud_cert_enable_on_basic_info: 'gb_cloud_cert_enable_on_basic_info',
  gb_show_developer_referral_source: 'gb_show_developer_referral_source',
  gb_cloud_cert_enable_on_resume_builder: 'gb_cloud_cert_enable_on_resume_builder',
  gb_comms_email_reminder_template: 'gb_comms_email_reminder_template',
  gb_notification_feature: 'gb_notification_feature',
  gb_resume_parser: 'gb_resume_parser',
  gb_seniority_improvement_conversion: 'gb_seniority_improvement_conversion',
  gb_ui_ux_improved_version: 'gb_ui_ux_improved_version',
  gb_ui_ux_version: 'gb_ui_ux_version',
  gb_ui_ux_improvement: 'gb_ui_ux_improvement',
  gb_ui_ux_version_step_2_3: 'gb_ui_ux_version_step_2_3',
  gb_job_opportunity_popup: 'gb_job_opportunity_popup',
  gb_reddit_jobs_for_logo: 'gb_reddit_jobs_for_logo',
  gb_legacy_jobs: 'gb_legacy_jobs',
  getmatchedpagenewvsold: 'getmatchedpagenewvsold',
  homepagenewvsold: 'homepagenewvsold',
  importgmailcontactfeature: 'importgmailcontactfeature',
  jobspagenewvsold: 'jobspagenewvsold',
  lcipageautomatedvsregular: 'lcipageautomatedvsregular',
  mcqresetemail: 'mcqresetemail',
  show_companies_and_testimonial: 'show_companies_and_testimonial',
  skipresumebuttonnewvsold: 'skipresumebuttonnewvsold',
  use_mcq_engine: 'use_mcq_engine',
  use_vetting_engine_acc: 'use_vetting_engine_acc',
  use_apt_python: 'use_apt_python',
  use_apt_react: 'use_apt_react',
  disable_devstatus_check_on_mcq: 'disable_devstatus_check_on_mcq',
  enable_github_collection: 'enable_github_collection',
  use_multiple_apt: 'use_multiple_apt',
  enable_social_proof: 'enable_social_proof',
  show_apt_plagiarism_warning: 'show_apt_plagiarism_warning',
  gb_apt_instructions_config: "gb_apt_instructions_config",
  use_vetting_engine_redirection: 'use_vetting_engine_redirection',
  show_apt_requirements_warning: 'show_apt_requirements_warning',
  use_whizlab_cloud_challenge: 'use_whizlab_cloud_challenge',
  mcq_use_apiv1: 'mcq_use_apiv1',
  tofu_p1_ranker: 'tofu_p1_ranker',
  acc_use_apiv1: 'acc_use_apiv1',
  maintenance_mcq_acc_apt: 'maintenance_mcq_acc_apt',
  use_vetsmith_challenge_versioning: 'use_vetsmith_challenge_versioning',
  use_vetsmith_mcq_challenge_versioning: 'use_vetsmith_mcq_challenge_versioning',
  soft_skills_videos: 'soft_skills_videos',
  enable_soft_skills: 'enable_soft_skills',
  jobs_dashboard:'jobs_dashboard',
  job_dashboard_v2: 'job_dashboard_v2',
  job_dashboard_contents: 'job_dashboard_contents',
  vetsmith_flow_ids_hide_acc_proctoring_modal: 'vetsmith_flow_ids_hide_acc_proctoring_modal',
  use_mcq_proctoring: 'use_mcq_proctoring',
  use_onboarding_improved_ui_ux_multi_variant: 'use_onboarding_improved_ui_ux_multi_variant',
  new_ui_ux_onboarding_revamped_skipped_roles: 'new_ui_ux_onboarding_revamped_skipped_roles',
  use_remove_update_fields_in_onboarding_form_v2: 'use_remove_update_fields_in_onboarding_form_v2',
  use_role_based_mcq_uiux: 'use_role_based_mcq_uiux',
  developer_jobs_feedback: 'developer_jobs_feedback',
  new_job_request_form_dev_portal: 'new_job_request_form_dev_portal',
  use_new_resume_upload: 'use_new_resume_upload',
  use_new_linkedin_experiment: 'use_new_linkedin_experiment',
  use_make_rate_more_prominent: 'use_make_rate_more_prominent',
  use_collect_availability_post_onboarding: 'use_collect_availability_post_onboarding',
  use_multiple_acc_flow : 'use_multiple_acc_flow',
  hide_referral_section: 'hide_referral_section',
  hide_admin_routes: 'hide_admin_routes',
  use_homepage_revamp: 'use_homepage_revamp',
  enable_language_quiz: 'enable_language_quiz',
  use_application_tracking_ui: 'use_application_tracking_ui',
  use_settings_page_v2: 'use_settings_page_v2',
  use_new_quiz_page: 'use_new_quiz_page',
  use_new_challenges_page: 'use_new_challenges_page',
};

export { withLDFlagsFromBackend, GB_FLAGS, JobsPages, isJobPageFeatureEnabled };
export default useFlagsFromBackend;
